import { Button, TOUCH } from "@nymbl/nos2-rules";
import { ArrowDown, ArrowUp } from "lucide-react";
import type { SortDir } from "@/lib/time/table-view";
import { cn } from "@/lib/utils";

interface SortHeaderProps {
  label: string;
  sub?: string;
  /** "today" colors the sub-label with the accent (the mockup's Today). */
  subTone?: "today" | "muted";
  active: boolean;
  dir: SortDir | undefined;
  onClick: () => void;
  className?: string;
}

/** A sortable column header (UI standard 8). The th carries aria-sort; this is its button. */
export function SortHeader({
  label,
  sub,
  subTone = "today",
  active,
  dir,
  onClick,
  className,
}: SortHeaderProps) {
  const Icon = dir === "desc" ? ArrowDown : ArrowUp;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={cn("h-auto flex-col gap-0 px-2 py-1 font-semibold", TOUCH, className)}
    >
      <span className="flex items-center gap-1">
        {label}
        {active && <Icon className="size-3" aria-hidden="true" />}
      </span>
      {sub && (
        <span
          className={cn(
            "text-xs font-normal",
            subTone === "today" ? "text-info" : "text-muted-foreground",
          )}
        >
          {sub}
        </span>
      )}
    </Button>
  );
}

export function ariaSort(active: boolean, dir: SortDir | undefined) {
  if (!active) return "none" as const;
  return dir === "desc" ? ("descending" as const) : ("ascending" as const);
}
